module.exports = "Select the editing functions from the “Image Adjust” section of our editor"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoEditor/photo-editor-how-to-step-two.md
// module id = 1167
// module chunks = 0